package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.RelatorioFotoCatalog
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.ItemConformidadeCard
import br.com.htms.inspeccaocampo.shared.ui.components.LegendaConformidade
import br.com.htms.inspeccaocampo.shared.ui.components.PreviaAntesSalvarDialog
import br.com.htms.inspeccaocampo.shared.ui.components.RotuloConformidade
import br.com.htms.inspeccaocampo.shared.ui.components.SharedFotosMenu
import br.com.htms.inspeccaocampo.ui.FormPrevia
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedRelatorioFotoScreen(
    controller: AppController,
    modoCombinado: Boolean = false,
    onAvancarParte2: (() -> Unit)? = null
) {
    val form by controller.relatorioForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()

    val snackbar = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var menuObraAberto by remember { mutableStateOf(false) }
    var mostrarListaObs by remember { mutableStateOf(false) }
    var mostrarPrevia by remember { mutableStateOf(false) }

    fun scrollSeguro(index: Int) {
        scope.launch {
            val total = listState.layoutInfo.totalItemsCount
            if (total <= 0) return@launch
            listState.animateScrollToItem(index.coerceIn(0, total - 1))
        }
    }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
    }

    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    LaunchedEffect(erros) {
        if (erros.isEmpty()) return@LaunchedEffect
        runCatching { listState.animateScrollToItem(0) }
    }

    val secoes = RelatorioFotoCatalog.secoesPadrao()

    fun abrirFotoObservacoes(fromGallery: Boolean = false) {
        controller.adicionarFotoObservacoesRelatorio(fromGallery)
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbar) }
    ) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .background(Color.Transparent)
        ) {
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(listState, Modifier.fillMaxSize()) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(bottom = 96.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                if (!modoCombinado) {
                    item {
                        Row(
                            Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp),
                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            PortalOutlinedButton(
                                onClick = { controller.solicitarSaidaDoFormulario { controller.voltarAoHub() } },
                                modifier = Modifier.weight(1f)
                            ) { Text("Voltar ao hub") }
                        }
                    }
                }

                item {
                    LegendaConformidade(
                        modifier = Modifier.padding(horizontal = 16.dp),
                        rotulos = RotuloConformidade.SIM_NAO_NA
                    )
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            TituloSecao("Dados do relatório")
                            AppOutlinedTextField(
                                value = form.responsavelAlojamento,
                                onValueChange = { v ->
                                    controller.atualizarRelatorio { it.copy(responsavelAlojamento = v) }
                                },
                                label = { Text("Responsável pelo Alojamento *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("responsavelAlojamento") != null
                            )
                            AppOutlinedTextField(
                                value = form.endereco,
                                onValueChange = { v ->
                                    controller.atualizarRelatorio { it.copy(endereco = v) }
                                },
                                label = { Text("Endereço *") },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 2,
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("endereco") != null
                            )
                            AppDateTextField(
                                value = form.dataInicioContrato,
                                onValueChange = { v ->
                                    controller.atualizarRelatorio { it.copy(dataInicioContrato = v) }
                                },
                                label = "Data de início do contrato *",
                                kind = DateFieldKind.DATE,
                                isError = controller.erroNoCampo("dataInicioContrato") != null
                            )
                            br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                label = "Obra *",
                                opcoes = obrasAtivas.map { it.nome to it.nome },
                                selecionado = form.obra,
                                onSelect = { v -> controller.atualizarRelatorio { it.copy(obra = v) } },
                                isError = controller.erroNoCampo("obra") != null
                            )
                            AppOutlinedTextField(
                                value = form.dataHorarioFormatado(),
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Data e horário (automático)") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors()
                            )
                        }
                    }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = PortalCores.AzulClaro)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            TituloSecao("Quantidades")
                            campoNumerico(
                                valor = form.capacidadeTotalPessoas,
                                label = "Capacidade total de pessoas *",
                                campo = "capacidadeTotalPessoas",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(capacidadeTotalPessoas = v) }
                                }
                            )
                            campoNumerico(
                                valor = form.quantidadeFuncionarios,
                                label = "Quantidade de funcionários *",
                                campo = "quantidadeFuncionarios",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(quantidadeFuncionarios = v) }
                                }
                            )
                            campoNumerico(
                                valor = form.quantidadeQuartos,
                                label = "Quantidade de quartos *",
                                campo = "quantidadeQuartos",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(quantidadeQuartos = v) }
                                }
                            )
                            campoNumerico(
                                valor = form.quantidadeCamas,
                                label = "Quantidade de camas *",
                                campo = "quantidadeCamas",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(quantidadeCamas = v) }
                                }
                            )
                            campoNumerico(
                                valor = form.quantidadeArmarios,
                                label = "Quantidade de armários *",
                                campo = "quantidadeArmarios",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(quantidadeArmarios = v) }
                                }
                            )
                            campoNumerico(
                                valor = form.quantidadeBanheiros,
                                label = "Quantidade de banheiros *",
                                campo = "quantidadeBanheiros",
                                controller = controller,
                                onChange = { v ->
                                    controller.atualizarRelatorio { it.copy(quantidadeBanheiros = v) }
                                }
                            )
                        }
                    }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = PortalCores.AzulClaro)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            TituloSecao("Local (GPS)")
                            AppOutlinedTextField(
                                value = form.localTexto.ifBlank { "Aguardando GPS..." },
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Local (GPS)") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("localGps") != null
                            )
                            if (form.latitude != null && form.longitude != null) {
                                Text(
                                    "Lat: ${form.latitude}  Lng: ${form.longitude}",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                            }
                            PortalOutlinedButton(
                                onClick = { controller.capturarGpsRelatorio() },
                                enabled = !capturandoGps,
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                ButtonLoadingContent(
                                    loading = capturandoGps,
                                    loadingText = "Capturando GPS...",
                                    idleText = "Atualizar local por GPS"
                                )
                            }
                        }
                    }
                }

                secoes.forEach { secao ->
                    val itensSecao = form.itens.filter { it.secao == secao.titulo }
                    if (itensSecao.isEmpty()) return@forEach
                    item {
                        Text(
                            secao.titulo,
                            modifier = Modifier.padding(horizontal = 16.dp),
                            fontWeight = FontWeight.Bold,
                            color = PortalCores.Navy
                        )
                    }
                    items(itensSecao, key = { it.id }) { item ->
                        ItemConformidadeCard(
                            item = item,
                            erro = controller.erroNoCampo(item.id),
                            onResposta = { controller.definirRespostaRelatorio(item.id, it) },
                            onJustificativa = { txt ->
                                controller.atualizarItemRelatorio(item.id) { it.copy(justificativa = txt) }
                            },
                            onValorExtra = { txt ->
                                controller.atualizarItemRelatorio(item.id) { it.copy(valorExtra = txt) }
                            },
                            onTirarFoto = { controller.adicionarFotoRelatorio(item.id) },
                            onAdicionarMaisFoto = { controller.adicionarFotoRelatorio(item.id) },
                            onRemoverFoto = { foto -> controller.removerFotoRelatorio(item.id, foto) },
                            onGaleria = {
                                controller.adicionarFotoRelatorio(item.id, fromGallery = true)
                            },
                            rotulos = RotuloConformidade.SIM_NAO_NA,
                            modifier = Modifier.padding(horizontal = 16.dp)
                        )
                    }
                }

                item {
                    Text(
                        RelatorioFotoCatalog.SECAO_OBSERVACOES,
                        modifier = Modifier.padding(horizontal = 16.dp),
                        fontWeight = FontWeight.Bold,
                        color = PortalCores.Navy
                    )
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            AppOutlinedTextField(
                                value = form.observacoesGerais,
                                onValueChange = { v ->
                                    controller.atualizarRelatorio { it.copy(observacoesGerais = v) }
                                },
                                label = { Text("Observações") },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 3,
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("observacoesGerais") != null
                            )
                            CampoFotoRow(
                                label = "Câmera",
                                obrigatorio = false,
                                quantidadeFotos = form.observacoesFotos.size,
                                onTirarFoto = { abrirFotoObservacoes() },
                                onAdicionarMais = { abrirFotoObservacoes() },
                                onAbrirLista = { mostrarListaObs = true },
                                onGaleria = { abrirFotoObservacoes(fromGallery = true) }
                            )
                            if (form.observacoesFotos.isNotEmpty() && form.observacoesGerais.isBlank()) {
                                Text(
                                    "Com foto anexada, descreva a observação.",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.error
                                )
                            }
                        }
                    }
                }

                if (erros.isNotEmpty()) {
                    item {
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(
                                containerColor = MaterialTheme.colorScheme.errorContainer
                            )
                        ) {
                            Column(
                                modifier = Modifier.padding(12.dp),
                                verticalArrangement = Arrangement.spacedBy(6.dp)
                            ) {
                                Text("Corrija os campos obrigatórios:", fontWeight = FontWeight.Bold)
                                erros.take(5).forEach { erro ->
                                    Text(
                                        text = "• ${erro.mensagem}",
                                        color = MaterialTheme.colorScheme.onErrorContainer,
                                        textDecoration = TextDecoration.Underline,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .clickable { scope.launch { listState.animateScrollToItem(0) } }
                                            .padding(vertical = 4.dp)
                                    )
                                }
                                if (erros.size > 5) {
                                    Text("... e mais ${erros.size - 5}")
                                }
                            }
                        }
                    }
                }

                item {
                    PortalButton(
                        onClick = {
                            if (modoCombinado) {
                                controller.syncCamposCompartilhadosAlojamento()
                                onAvancarParte2?.invoke()
                            } else {
                                mostrarPrevia = true
                            }
                        },
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)
                    ) {
                        Text(if (modoCombinado) "Ir para Parte 2" else "Prévia e salvar")
                    }
                }
            }
            }

            Column(
                modifier = Modifier
                    .align(Alignment.BottomEnd)
                    .padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                FloatingActionButton(
                    onClick = { scrollSeguro(0) },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Início", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
                FloatingActionButton(
                    onClick = {
                        val last = (listState.layoutInfo.totalItemsCount - 1).coerceAtLeast(0)
                        scrollSeguro(last)
                    },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Fim", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
            }
        }
    }

    if (mostrarPrevia) {
        PreviaAntesSalvarDialog(
            linhas = FormPrevia.relatorioFoto(form),
            onConfirmar = { controller.validarESalvarRelatorio() },
            onDismiss = { mostrarPrevia = false }
        )
    }

    if (mostrarListaObs) {
        SharedFotosMenu(
            titulo = "${RelatorioFotoCatalog.SECAO_OBSERVACOES} — fotos",
            fotos = form.observacoesFotos,
            aberto = true,
            onFechar = { mostrarListaObs = false },
            onRemover = { controller.removerFotoObservacoesRelatorio(it) }
        )
    }
}

@Composable
private fun campoNumerico(
    valor: String,
    label: String,
    campo: String,
    controller: AppController,
    onChange: (String) -> Unit
) {
    AppOutlinedTextField(
        value = valor,
        onValueChange = { raw -> onChange(raw.filter { it.isDigit() }) },
        label = { Text(label) },
        modifier = Modifier.fillMaxWidth(),
        colors = FormFieldDefaults.textFieldColors(),
        isError = controller.erroNoCampo(campo) != null
    )
}
